import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getSessionSeverities } from 'src/apps/mfa/services/MfaSingleSessionService';
import { ISeverityCountType } from 'src/common/components/mobile-scans-impacted-by-severity-chart/MobileScansImpactedBySeverityChart';
import { MFA_SESSION_SEVERITIES } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseMfaSessionSeveritiesQuery {
	sessionId: string;
}

export const useMfaSessionSeveritiesQuery = ({
	sessionId
}: IUseMfaSessionSeveritiesQuery): UseQueryResult<ISeverityCountType[]> => {
	const componentsQuery = useQuery(
		[MFA_SESSION_SEVERITIES, sessionId],
		async (): Promise<ISeverityCountType[]> =>
			getSessionSeverities({
				sessionId
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return componentsQuery;
};
